import { Container } from '@mantine/core';
import classes from './Footer.module.css';
import React from 'react';

function FooterSimple() {

  return (
    <div className={classes.footer}>
      <Container className={classes.inner} >
      ©
        <script>
            document.write(new Date().getFullYear());
        </script>
        , made with ❤️ by FAME
      </Container>

    </div>

  );
}

export default FooterSimple;
